import React, { useState, ChangeEvent, useEffect } from 'react';
import './CreditNumber.css';
import { STORAGE_ASSETS } from '../../Const/BaseUrlConst';

interface CreditNumberProps {
    textCard?: boolean;
    brandCard?: string;
    lastDigits?: string;
}

export const CreditNumber: React.FC<CreditNumberProps> = ({
    textCard=false,
    brandCard='visa',
    lastDigits=''
}) => {

  const [cardType, setCardType] = useState(STORAGE_ASSETS+'/images/svg/visa.svg');
  const [cardName, setCardName] = useState('');


  const getBrandCardName = (brand: string) => {
    if (brand.toLocaleLowerCase().includes("visa")) {
      setCardType(STORAGE_ASSETS+'/images/png/visa.png');
      setCardName('Visa');
    } else if (brand.toLocaleLowerCase().includes("mastercard")) {
      setCardType(STORAGE_ASSETS+'/images/png/mastercard.png');
      setCardName('Mastercard');
    } else if (brand.toLowerCase().includes('amex')) {
      setCardType(STORAGE_ASSETS+'/images/svg/amex.svg');
      setCardName('American Express');
    } else if (brand.toLowerCase().includes('diners')) {
      setCardType(STORAGE_ASSETS+'/images/svg/diners.svg');
      setCardName('Diners Club');
    } else {
      setCardName('');
    }
  }

  useEffect(() => {
    if (brandCard) {
      getBrandCardName(brandCard);
    }
  }, [brandCard]);


  return (
    <div className='creditNumber'>
       {!textCard && <div className='tinytext-header creditNumber-textColor'>Tarjeta de pago</div>}
        <div className='creditNumber-input'>
            <div className='creditNumber-data'>
              <div className='creditNumber-icon'>
                  <img src={cardType}/>
              </div>
            {lastDigits.length>0 && <div className='paragraph-subheader creditNumber-number'>**** **** {lastDigits}</div>}
            </div>
            {textCard && <div className='creditNumber-text'>{cardName}</div>}        
        </div>
    </div>
  );
};
